module.exports = __webpack_public_path__ + "nc_static/media/marketAnalysis.1aebc710.svg";